import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import AppMenu from "../../menu";
import TablesData from "../globalTable";
import TableItem from "../globalTable/tableItem";
import { SearchOnly } from "../globalTable/searchandfilter";
import ActionModal from "../modals";
import ActionModalContent from "../modals/modalContent";
import {
  fetchBasicHealthCareUserPendingRequest,
  getBasicHealthCareUsers,
} from "../../../store/basicHealthCare";
import { useDispatch, useSelector } from "react-redux";
import { getFormatedDate } from "../../../utils/constants";
import Loader from "../../common/Loader";
import { acceptUserRequest } from "../../../store/user";
import notification from "../../common/Alert";

export default function PendingBasicHealthCareRequest() {
  const history = useHistory();
  const [search, setSearch] = useState("");
  const [modal, setModal] = useState(false);
  const [content, setContent] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [selected, setSelected] = useState([]);
  let [pageNumber, setPageNumber] = useState(1);
  let [pageLists, setPageLists] = useState(10);

  const dispatch = useDispatch();
  const usersData = useSelector(getBasicHealthCareUsers);

  useEffect(() => {
    const fetchUsers = async () => {
      await dispatch(
        fetchBasicHealthCareUserPendingRequest(pageLists, pageNumber)
      );
    };
    fetchUsers();
  }, [dispatch, pageNumber, pageLists]);

  const incrementPageNumber = async () => {
    setPageNumber((pageNumber += 1));
    await dispatch(
      fetchBasicHealthCareUserPendingRequest(pageLists, pageNumber)
    );
  };

  const decrementPageNumber = async () => {
    setPageNumber((pageNumber -= 1));
    await dispatch(
      fetchBasicHealthCareUserPendingRequest(pageLists, pageNumber)
    );
  };

  const handleSelectNumber = ({ target }) => {
    if (target.value === "30") {
      setPageLists(30);
    } else if (target.value === "20") {
      setPageLists(20);
    } else {
      setPageLists(10);
    }
  };

  const accept_request = async (id, value) => {
    setModal(false);
    const acceptRequest = await dispatch(
      acceptUserRequest(id, { request_code: value })
    );
    notification.notication("success", acceptRequest.payload.message, "", {
      position: "top-right",
    });
    await dispatch(fetchBasicHealthCareUserPendingRequest(10, 1));
  };

  const handleCloseModal = () => {
    setModal(false);
  };

  const handleOpenConfirmModal = (userName, id) => {
    setModal(true);
    setContent(
      <ActionModalContent
        approveTextTop={
          <p>
            Please enter the Authorization Code to accept <b>{userName}</b>{" "}
            Basic Health care appointment.
          </p>
        }
        enroleeIdLabel
        formSection
        onApprove={(value) => accept_request(id, value)}
        onApproveSection
        onDecline={() => setModal(false)}
      />
    );
    setModalTitle("Confirm Basic Health Care Request");
  };

  const handleChange = (e) => {
    e.preventDefault();
    setSearch(e.target.value);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };
  const isSelected = (name) => selected.indexOf(name) !== -1;

  const handleSelectAllClick = () => {
    const newSelecteds = usersData?.pendingBasicHealthCareRequestList?.map(
      (n) => n.id
    );
    setSelected(newSelecteds);
    return;
  };

  const handleSearchAndFilter =
    usersData?.pendingBasicHealthCareRequestList?.filter((searched) => {
      if (search === " ") {
        return searched;
      } else if (
        searched?.first_name
          .toLowerCase()
          .includes(search && search.toLowerCase()) ||
        searched?.last_name
          .toLowerCase()
          .includes(search && search.toLowerCase()) ||
        searched?.phone_number?.includes(search && search?.toLowerCase())
      ) {
        return searched;
      } else {
        return null;
      }
    });
  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "2rem",
        }}>
        <SearchOnly handleSearch={handleChange} searchWord={search} />
      </div>
      <Loader visible={usersData?.loading} />
      <TableItem
        userType="User"
        modal={
          <ActionModal
            modalTitle={modalTitle}
            content={content}
            open={modal}
            close={handleCloseModal}
          />
        }
        checkBoxes
        tabHeadLabel={[
          "User",
          "Hospital Name",
          "Doctor's Name",
          "Amount",
          "Date Created",
        ]}
        action
        tableSize
        tabToolBar
        tabHeadCheck
        numSelectedItem={selected.length}
        rowCount={usersData?.pendingBasicHealthCareRequestList?.length}
        numSelected={selected.length}
        onSelectAllClick={handleSelectAllClick}
        currentPage={usersData?.currentPage}
        toPage={usersData?.toPage}
        totalPage={usersData?.total}
        handleIncrement={() => incrementPageNumber()}
        handleDecrement={() => decrementPageNumber()}
        disabledIncrement={pageNumber >= usersData.lastPage}
        disabledDecrement={pageNumber <= 1}
        handleSelectPageNumber={handleSelectNumber}
        pageSelectValue={pageLists}
        tabBodyData={handleSearchAndFilter?.map((item, i) => {
          const isItemSelected = isSelected(item.id);
          const labelId = `enhanced-table-checkbox-${i}`;
          return (
            <TablesData
              labelId={labelId}
              handleItemClick={(event) => handleClick(event, item?.id)}
              aria-checked={isItemSelected}
              isItemSelected={isItemSelected}
              key={i}
              checkBoxes
              image
              imageUrl={item?.user_photo}
              imgInitials={
                item?.first_name.slice(0, 1) + item?.last_name.slice(0, 1)
              }
              enroleeName={item?.first_name + " " + item?.last_name}
              listItem={[
                item?.hospital_name,
                item?.doctor_name,
                item?.amount,
                getFormatedDate(item?.appointment_date, "YYYY/MMM/DD"),
              ]}
              action={
                <AppMenu
                  menu_name_or_icon={<MoreHorizIcon />}
                  item_names={[
                    {
                      "View More": () =>
                        history.push(
                          `/wellness-on-the-go/user/basic-health-care/accept/${item?.user_id}`
                        ),
                    },
                  ]}
                />
              }
            />
          );
        })}
        tablePagination
      />
    </>
  );
}
